

import profile from './ProfileReducer';


export default profile;
